<template>
  <div class="layout-menu">
    <template v-if="isMenuLoadingFinished">
      <el-menu
        :default-active="menuCurrentSelect.key"
        :default-openeds="menuDefaultOpens"
        @open="handleOpen"
        @close="handleClose"
      >
        <template v-for="firstLevel in menu">
          <!-- 有二级菜单 -->
          <el-submenu
            v-if="firstLevel.children && firstLevel.children.length"
            :key="firstLevel.id"
            :index="firstLevel.id"
            :class="menuCurrentSelect.keyPath.includes(firstLevel.id) && 'first-level-active'"
          >
            <template slot="title">
              <i :class="`iconfont icon-${firstLevel.icon}`" />
              <span class="menu_title">{{ firstLevel.title }}</span>
            </template>
            <template v-for="secondLevel in firstLevel.children">
              <!-- 有三级菜单 -->
              <el-popover
                :key="secondLevel.id"
                v-if="secondLevel.children && secondLevel.children.length"
                placement="right-start"
                trigger="hover"
                popper-class="menu_third_level"
                @show="handleThirdLevelCollapse('show', secondLevel.id)"
                @hide="handleThirdLevelCollapse('hide', secondLevel.id)"
              >
                <!-- 三级菜单内容 -->
                <div class="menu_third_level_content">
                  <template v-for="thirdLevel in secondLevel.children">
                    <!-- 有四级菜单 -->
                    <template v-if="thirdLevel.children && thirdLevel.children.length">
                      <el-menu-item
                        :key="thirdLevel.id"
                        :index="thirdLevel.id"
                        :class="`${menuCurrentSelect.keyPath.includes(thirdLevel.id) && 'third-level-active'}`"
                      >
                        <i :class="`iconfont icon-${thirdLevel.icon}`" />
                        <span slot="title" class="menu_title">{{ thirdLevel.title }}</span>
                      </el-menu-item>
                      <div
                        v-for="forthLevel in thirdLevel.children"
                        :key="forthLevel.id"
                        @click="handleMenuItemClick(forthLevel)"
                      >
                        <el-menu-item
                          :index="forthLevel.id"
                          :class="`menu_forth_level ${
                            menuCurrentSelect.keyPath.includes(forthLevel.id) && 'forth-level-active'
                          }`"
                          :disabled="forthLevel.disabled"
                        >
                          {{ forthLevel.title }}
                        </el-menu-item>
                      </div>
                    </template>
                    <!-- 无四级菜单 -->
                    <div v-else :key="thirdLevel.id" @click="handleMenuItemClick(thirdLevel)">
                      <el-menu-item
                        :index="thirdLevel.id"
                        :class="`${menuCurrentSelect.keyPath.includes(thirdLevel.id) && 'third-level-active'}`"
                      >
                        <i :class="`iconfont icon-${thirdLevel.icon}`" />
                        <span slot="title" class="menu_title">{{ thirdLevel.title }}</span>
                      </el-menu-item>
                    </div>
                  </template>
                </div>
                <!-- 二级菜单trigger -->
                <el-menu-item
                  slot="reference"
                  :key="secondLevel.id"
                  :index="secondLevel.id"
                  :class="{
                    'second-level-active': menuCurrentSelect.keyPath.includes(secondLevel.id),
                    'third-level-expand': secondLevel.expand,
                  }"
                >
                  {{ secondLevel.title }}
                  <i class="third-level-open iconfont icon-menu-open" />
                </el-menu-item>
              </el-popover>
              <!-- 无三级菜单 -->
              <div
                class="second-level-no-children"
                v-else
                :key="secondLevel.id"
                @click="handleMenuItemClick(secondLevel)"
              >
                <el-menu-item :index="secondLevel.id">
                  {{ secondLevel.title }}
                  <img
                    v-if="secondLevel.tags && secondLevel.tags.includes('beta')"
                    class="icon-beta"
                    src="@/assets/img/LayoutMenu/icon-beta.png"
                    alt="beta"
                  />
                  <img
                    v-if="secondLevel.tags && secondLevel.tags.includes('new')"
                    class="icon-new"
                    src="@/assets/img/LayoutMenu/icon-new.png"
                    alt="new"
                  />
                  <img
                    v-if="secondLevel.tags && secondLevel.tags.includes('free')"
                    class="icon-free"
                    src="@/assets/img/LayoutMenu/icon-free.svg"
                    alt="beta"
                  />
                </el-menu-item>
              </div>
            </template>
          </el-submenu>
          <!-- 无二级菜单 -->
          <div v-else :key="firstLevel.id" @click="handleMenuItemClick(firstLevel)">
            <el-menu-item :index="firstLevel.id">
              <i :class="`iconfont icon-${firstLevel.icon}`" />
              <span slot="title" class="menu_title">{{ firstLevel.title }}</span>
            </el-menu-item>
          </div>
        </template>
      </el-menu>
    </template>
    <template v-else>
      <el-skeleton animated :count="12">
        <template slot="template">
          <el-skeleton-item variant="text" class="skeleton-item" />
        </template>
      </el-skeleton>
    </template>
    <DialogFreeTrial v-if="showDialogFreeTrial" @close="showDialogFreeTrial = false" @success="paySuccess" />
    <DialogPurchaseIntentionBuy
      v-if="showDialogPurchaseIntention"
      @close="showDialogPurchaseIntention = false"
      @success="purchaseSuccess"
    />
  </div>
</template>

<script>
import { OLD_USER_CENTER_URL, OLD_SEARCH_URL } from "@/utils/constants/constants";
import {
  OLD_SUBSCRIBE_CENTER_SUBSCRIBE_INFO_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_INFO_CONSTR_PROJECT_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_INFO_EXAMINE_PROJECT_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
  MENU,
} from "@/utils/constants/constants.menu";
import { authCheck } from "@/utils/common";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";
import {
  restAccountSubscribeGrayGetVersion,
  restApiAccountSubscribeLaveSubscriberCount,
  restAccountCompanySpaceCheckSubscribeCreatePermission,
} from "@/services/common/subscribe";
import { restAccountTenderSubscribeGetSubscriberListByUserId } from "@/services/subscribe-center/subscribe.bidding-info";
import { restAccountWillBuildSubscribeGetSubscriberListByUserId } from "@/services/subscribe-center/subscribe.constr-project";
import { restAccountApprovalSubscribeGetSubscriberListByUserId } from "@/services/subscribe-center/subscribe.examine-project";
import { restApplicationMyApplicationControllerGetMyApplication } from "@/services/common/basic";
import {
  restApplicationPurchasePermissionInfo,
  restAccountCompanySpaceCheckPurchaseSubPermission,
} from "@/services/business-opportunity/purchase-intention";

import { setUserInfo } from "@/utils/common";

export default {
  name: "LayoutMenu",
  components: {
    DialogFreeTrial: () => import("@/components/BusinessOpportunity/common/DialogFreeTrial.vue"),
    DialogPurchaseIntentionBuy: () => import("@/components/BusinessOpportunity/common/DialogPurchaseIntentionBuy.vue"),
  },
  data() {
    return {
      menuCurrentSelect: {
        key: "",
        keyPath: [],
        scrollBehaviour: "none", // "smooth" "none"
      },
      menuSubscribeCenterLoaded: false,
      menuMyApplicationsLoaded: false,
      menuEnterpriseManageLoaded: false,
      isTwoPointEightAccountLoaded: false,
      MENU,
      showDialogFreeTrial: false,
      showDialogPurchaseIntention: false,
    };
  },
  computed: {
    menu() {
      return this.$store.getters["layout/menu"];
    },
    menuCurrentSelectConditions() {
      return {
        fullPath: this.$route.fullPath,
        menu: this.$store.getters["layout/menu"],
      };
    },
    menuDefaultOpens() {
      return this.$store.getters["layout/menuDefaultOpens"];
    },
    /** 订阅中心 **/
    menuSubscribeCenterConditions() {
      return {
        grayReleaseFeatures: this.$store.getters["basic/grayReleaseFeatures"],
        subscribeVersionUserSetting: this.$store.getters["subscribe/subscribeVersionUserSetting"],
      };
    },
    /** 全部应用 **/
    menuMyApplicationsConditions() {
      return this.$store.getters["basic/myApplications"];
    },
    /** 企业管理 **/
    menuEnterpriseManageConditions() {
      return {
        userId: this.$store.getters["basic/userInfo"].userId,
        isMainAccount: this.$store.getters["basic/userInfo"].roleId === 1,
        hasChildAccount: this.$store.getters["basic/userInfo"].maxChildCount > 0,
        isTwoPointFiveAccount: this.$store.getters["basic/isTwoPointFiveAccount"],
        memberLevel: this.$store.getters["basic/userInfo"].memberLevel,
      };
    },
    isTwoPointEightAccount() {
      return this.$store.getters["basic/isTwoPointEightAccount"];
    },
    isMenuLoadingFinished() {
      return (
        this.menuSubscribeCenterLoaded &
        this.menuMyApplicationsLoaded &
        this.menuEnterpriseManageLoaded &
        this.isTwoPointEightAccountLoaded
      );
    },
  },
  watch: {
    menuCurrentSelectConditions: {
      handler(newV) {
        /** 路由、菜单 发生变化，修改当前选中菜单 **/
        const { fullPath, menu } = newV;
        this.getMenuCurrentSelect(menu, fullPath);
      },
    },
    menuSubscribeCenterConditions: {
      async handler(conditions) {
        const { subscribeVersionUserSetting } = conditions;
        /** 2668 订阅器切换交互调整**/
        /**
         * NEW_SUBSCRIBE_VERSION_ONE 样式2，
         * NEW_SUBSCRIBE_GRAY 样式1，
         * subscribeVersionUserSetting是否切换新版本
         独立于旧版，和当前灰度中的三级菜单样式（新样式1）。
         新样式2指定UID灰度（UID补充在禅道附件中），该灰度优先级高于新样式1。
         新样式2指定的UID也支持新旧版切换，在老样式和新样式2之间切换
         新样式1 也支持新旧版切换，在老样式和新样式1之间切换
         **/
        if (authCheck(AUTH_KEY_MAP.NEW_SUBSCRIBE_VERSION_ONE) && subscribeVersionUserSetting === 1) {
          //显示新样式2
          const menu = this.menu.map((firstLevel) => {
            if (firstLevel.title === "订阅中心") {
              firstLevel.children = firstLevel.children.map((secondLevel) => {
                if (secondLevel.title === "订阅信息") {
                  delete secondLevel.children;
                }
                return secondLevel;
              });
            }
            return firstLevel;
          });
          this.$store.commit("layout/updateMenu", menu);
        } else if (
          //显示新样式1
          authCheck(AUTH_KEY_MAP.NEW_SUBSCRIBE_GRAY) &&
          subscribeVersionUserSetting === 1 &&
          !authCheck(AUTH_KEY_MAP.NEW_SUBSCRIBE_VERSION_ONE)
        ) {
          await this.getSubscribeList();
          const subscribeListMap = {
            biddingInfo: this.$store.getters["subscribe/biddingInfoSubscribeList"],
            constrProject: this.$store.getters["subscribe/constrProjectSubscribeList"],
            examineProject: this.$store.getters["subscribe/examineProjectSubscribeList"],
          };
          const { biddingInfo, constrProject, examineProject } = subscribeListMap;
          const getThirdLevelChildren = ({ thirdLevel, source, name, url }) => {
            if (source.length) {
              return source.map((item, index) => {
                return {
                  id: `${thirdLevel.id}-${index + 1}`,
                  title: item.subscribeName,
                  url: `${url}?id=${item.id}`,
                };
              });
            } else {
              return [
                {
                  id: `${thirdLevel.id}-0`,
                  title: `暂无${name}订阅器`,
                  url: null,
                  disabled: true,
                },
              ];
            }
          };
          const menu = this.menu.map((firstLevel) => {
            if (firstLevel.title === "订阅中心") {
              firstLevel.children = firstLevel.children.map((secondLevel) => {
                if (secondLevel.title === "订阅信息") {
                  secondLevel.children = secondLevel.children.map((thirdLevel) => {
                    if (thirdLevel.title === "标讯订阅") {
                      thirdLevel.children = getThirdLevelChildren({
                        thirdLevel,
                        source: biddingInfo,
                        name: "标讯",
                        url: SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL,
                      });
                    }
                    if (thirdLevel.title === "拟在建订阅") {
                      thirdLevel.children = getThirdLevelChildren({
                        thirdLevel,
                        source: constrProject,
                        name: "拟在建",
                        url: SUBSCRIBE_CENTER_SUBSCRIBE_INFO_CONSTR_PROJECT_URL,
                      });
                    }
                    if (thirdLevel.title === "审批订阅") {
                      thirdLevel.children = getThirdLevelChildren({
                        thirdLevel,
                        source: examineProject,
                        name: "审批",
                        url: SUBSCRIBE_CENTER_SUBSCRIBE_INFO_EXAMINE_PROJECT_URL,
                      });
                    }
                    return thirdLevel;
                  });
                }
                return secondLevel;
              });
            }
            return firstLevel;
          });
          this.$store.commit("layout/updateMenu", menu);
        } else {
          /** 否则 显示旧版目录 **/
          const menu = this.menu.filter((menuItem) => {
            if (menuItem.title === "订阅中心") {
              menuItem.children = [
                {
                  id: `${menuItem.id}-1`,
                  title: "订阅信息",
                  url: OLD_SUBSCRIBE_CENTER_SUBSCRIBE_INFO_URL,
                },
                {
                  id: `${menuItem.id}-2`,
                  title: "订阅管理",
                  url: SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
                },
              ];
            }
            return menuItem;
          });
          this.$store.commit("layout/updateMenu", menu);
        }

        /** 订阅器加载完毕 **/
        this.menuSubscribeCenterLoaded = true;
      },
    },
    menuMyApplicationsConditions: {
      handler(apps) {
        if (apps.length) {
          const menu = this.menu.reduce((menu, menuItem) => {
            // 全部应用
            if (menuItem.title === "全部应用") {
              menuItem.children = apps.reduce((children, app, index) => {
                /** 企业库 **/
                if (app.id === 1 && app.type === "enterpriseLibrary") {
                  //:TODO 可优化
                  children.push({
                    id: `${menuItem.id}-${index + 1}`,
                    title: app.appName,
                    url: app.appUrl.includes("http") ? app.appUrl : OLD_SEARCH_URL + app.appUrl,
                    tags: app.tags,
                  });
                  return children;
                }
                /** 企业监控 **/
                if (app.id === 4 && app.appName === "企业监控") {
                  children.push({
                    id: `${menuItem.id}-${index + 1}`,
                    title: app.appName,
                    url: app.appUrl, // 已在vue项目重构的，就不能增加origin，否则会导致menu-item is-active失效
                    tags: app.tags,
                  });
                  return children;
                }
                /** 集成CRM **/
                if (app.id === 27 && app.appName === "集成CRM") {
                  children.push({
                    id: `${menuItem.id}-${index + 1}`,
                    title: app.appName,
                    url: app.appUrl, // 已在vue项目重构的，就不能增加origin，否则会导致menu-item is-active失效
                    tags: app.tags,
                  });
                  return children;
                }
                /** 其他 **/
                children.push({
                  id: `${menuItem.id}-${index + 1}`,
                  title: app.appName,
                  url: app.appUrl.includes("http") ? app.appUrl : OLD_USER_CENTER_URL + app.appUrl,
                  tags: app.tags,
                });
                return children;
              }, []);
            }
            menu.push(menuItem);
            return menu;
          }, []);
          this.$store.commit("layout/updateMenu", menu);
        }

        /** 全部应用加载完毕 **/
        this.menuMyApplicationsLoaded = true;
      },
      immediate: true,
    },
    menuEnterpriseManageConditions: {
      handler(newV) {
        /**
         * 若不同时监听，会出现userInfo更新滞后于2.5权限的情况，导致其他问题
         * **/
        const { userId, isMainAccount, hasChildAccount, isTwoPointFiveAccount, memberLevel } = newV;
        /**
         * 解决 企业智能管理 被误隐藏，且无法再次显示 的问题
         * **/
        if (!userId) return;
        if (isTwoPointFiveAccount === null) return;

        let menu = this.menu;
        // 1、是主账号 展示 企业管理 菜单
        // 任意不满足，隐藏入口
        if (isMainAccount) {
          menu = menu.map((menuItem) => {
            if (menuItem.title === "企业管理") {
              const child = MENU.find((mItem) => mItem.title === "企业管理").children;
              menuItem.children = child.filter((v) => v.title === "子账号管理");

              if (memberLevel > 5 && hasChildAccount) {
                menuItem.children = child;
              }
            }

            return menuItem;
          });
        } else {
          menu = menu.filter((v) => v.title !== "企业管理");
        }

        // 2、2.5 比 2.0 多一个 企业智能管理
        // 若不满足，隐藏入口
        if (isMainAccount && !isTwoPointFiveAccount) {
          menu = menu.map((menuItem) => {
            if (menuItem.title === "企业管理")
              menuItem.children = menuItem.children.filter((v) => v.title !== "企业智能管理");
            return menuItem;
          });
        }

        this.$store.commit("layout/updateMenu", menu);

        /**
         * 企业管理入口权限加载完毕,
         * todo immediate的可以加入debounce来完全避免抖动，但耗时更长
         * **/
        this.menuEnterpriseManageLoaded = true;
      },
      immediate: true,
      deep: true,
    },
    isTwoPointEightAccount: {
      handler(newV) {
        /**
         * 如果是2.8账号，
         * 隐藏一些入口
         * -[x] 交易中心 - 服务列表
         * -[x] VIP服务 - *
         * -[x] 全部应用 - *
         * -[x] 千里马学院 - *
         * **/
        if (newV) {
          const menu = this.menu.filter((menuItem) => {
            if (menuItem.children) {
              menuItem.children = menuItem.children.filter((child) => {
                const hideChildMenuTitleList = ["服务列表"];
                return !hideChildMenuTitleList.includes(child.title);
              });
            }
            const hideMenuTitleList = ["VIP服务", "全部应用", "千里马学院"];
            return !hideMenuTitleList.includes(menuItem.title);
          });
          this.$store.commit("layout/updateMenu", menu);
        }
        /** 2.8账号end **/

        /**
         * 2.8权限加载完毕
         * todo immediate的可以加入debounce来完全避免抖动，但耗时更长
         * **/
        this.isTwoPointEightAccountLoaded = true;
      },
      immediate: true,
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log("open", key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log("Close", key, keyPath);
    },
    handleThirdLevelCollapse(type, secondLevelId) {
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].children) {
          for (let j = 0; j < this.menu[i].children.length; j++) {
            if (secondLevelId === this.menu[i].children[j].id) {
              switch (type) {
                case "show":
                  this.$set(this.menu[i].children[j], "expand", true);
                  break;
                case "hide":
                  this.$set(this.menu[i].children[j], "expand", false);
                  break;
              }
            }
          }
        }
      }
    },
    //从免费体验弹窗购买成功
    async paySuccess() {
      this.showDialogFreeTrial = false;
      await setUserInfo();
      location.reload();
    },
    //从立即购买弹窗购买成功
    async purchaseSuccess() {
      this.showDialogPurchaseIntention = false;
      await setUserInfo();
      location.reload();
    },
    // 判断采购意向权限
    async getPurchaseIntentionPermission() {
      return new Promise((resolve, reject) => {
        restApplicationPurchasePermissionInfo()
          .then((res) => {
            const { hasPermission, isReceive } = res.data;
            if (hasPermission) {
              resolve(true);
              return;
            }

            if (!hasPermission) {
              resolve(false);
            }

            if (isReceive) {
              this.showDialogPurchaseIntention = true;
            } else {
              this.showDialogFreeTrial = true;
            }
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    // 获取添加订阅器权限
    async getCreatedPurchaseIntentionSubPermission() {
      return new Promise((resolve) => {
        restAccountCompanySpaceCheckPurchaseSubPermission().then((res) => {
          const purchaseSubPermission = res.data;
          if (purchaseSubPermission === 0) {
            resolve(true);
            return;
          } else {
            resolve(false);
          }

          if (purchaseSubPermission === 1) {
            this.$libMsgBox({
              title: "订阅器数量已达上限",
              message: "请前往订阅管理删除部分订阅器后再继续创建",
              confirmButtonText: "前往订阅管理",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push({
                  path: SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
                });
              })
              .catch((e) => e);
          }

          if (purchaseSubPermission === 3) {
            this.$message({
              message: "暂无创建订阅器权限，请联系主账号开通权",
              type: "warning",
            });
          }
        });
      });
    },
    async handleMenuItemClick(menuItem) {
      /** 菜单跳转权限判断 **/
      switch (menuItem.title) {
        case "新增标讯订阅":
        case "新增拟在建订阅":
        case "新增审批订阅":
          // 创建权限判断

          if (!(await restAccountCompanySpaceCheckSubscribeCreatePermission().then((res) => res.data))) {
            this.$message({
              message: "暂无创建订阅器权限，请联系主账号开通权限",
              type: "warning",
            });
            return;
          }
          // 剩余数量判断
          if (await restApiAccountSubscribeLaveSubscriberCount().then((res) => res.data.laveCount <= 0)) {
            this.$libMsgBox({
              title: "订阅器数量已达上限",
              message: "请前往订阅管理删除部分订阅器后再继续创建",
              confirmButtonText: "前往订阅管理",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push({
                  path: SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
                });
              })
              .catch((e) => e);
            return;
          }
          break;
        case "新增采购意向订阅":
          if (!authCheck(AUTH_KEY_MAP.IS_MEMBER)) {
            this.$message({
              message: "您当前暂无权限，请联系专属客服升级会员",
              type: "warning",
            });
            return;
          }

          // 用户是否领取&购买有采购意向
          const permission = await this.getPurchaseIntentionPermission();
          if (!permission) {
            return;
          }

          if (permission) {
            const createdPermission = await this.getCreatedPurchaseIntentionSubPermission();
            if (!createdPermission) {
              return;
            }
          }
          break;
      }
      /** 菜单跳转权限判断 end **/

      const url = menuItem.url;
      if (url.includes("//") || url.includes(".html")) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    getMenuCurrentSelect(menu, fullPath) {
      function getMenuCurrentSelectProbably(menu, fullPath, callback) {
        for (let i = 0; i < menu.length; i++) {
          const menuItem = menu[i];
          /** 无子菜单 **/
          if (!menuItem.children || !menuItem.children.length) {
            const menuUrl = menuItem.url;
            /** includes("http")意味着是外链，不属于menu **/
            if (menuUrl && !menuUrl.includes("http")) {
              /** 当前路径包含菜单路径，则高亮选中 **/
              if (fullPath.includes(menuUrl)) {
                const idArr = menuItem.id.split("-");
                const keyPath = [];
                for (let j = 0; j < idArr.length; j++) {
                  let key = [];
                  for (let k = 0; k < j + 1; k++) {
                    key.push(idArr[k]);
                  }
                  keyPath.unshift(key.join("-"));
                }
                callback({
                  key: menuItem.id,
                  keyPath,
                  scrollBehaviour: "none", // "smooth" "none"
                  menuUrl,
                });
              }
            }
          } else {
            /** 有子菜单 **/
            getMenuCurrentSelectProbably(menuItem.children, fullPath, callback);
          }
        }
      }

      const current_select_probably = [];
      getMenuCurrentSelectProbably(menu, fullPath, (value) => {
        current_select_probably.push(value);
      });
      if (current_select_probably.length === 1) {
        this.menuCurrentSelect = current_select_probably[0];
      } else if (current_select_probably.length > 1) {
        this.menuCurrentSelect = current_select_probably.reduce((previousValue, currentValue) => {
          const a = fullPath.replace(previousValue.menuUrl, "").length;
          const b = fullPath.replace(currentValue.menuUrl, "").length;
          if (a < b) {
            return previousValue;
          } else {
            return currentValue;
          }
        });
      }
    },
    /** 获取订阅器新旧版本显示形式（用户设置） **/
    async getSubscribeVersionUserSetting() {
      const res = await restAccountSubscribeGrayGetVersion();
      this.$store.commit("subscribe/updateSubscribeVersionUserSetting", res.data);
    },
    async getSubscribeList() {
      await Promise.all([
        restAccountTenderSubscribeGetSubscriberListByUserId(),
        restAccountWillBuildSubscribeGetSubscriberListByUserId(),
        restAccountApprovalSubscribeGetSubscriberListByUserId(),
      ]).then((resList) => {
        const biddingInfoSubscribeList = resList[0].data;
        this.$store.commit("subscribe/updateBiddingInfoSubscribeList", biddingInfoSubscribeList);

        const constrProjectSubscribeList = resList[1].data;
        this.$store.commit("subscribe/updateConstrProjectSubscribeList", constrProjectSubscribeList);

        const examineProjectSubscribeList = resList[2].data;
        this.$store.commit("subscribe/updateExamineProjectSubscribeList", examineProjectSubscribeList);
      });
    },
    async getMyApplications() {
      // 获取全部应用
      let myApps;
      try {
        myApps = await restApplicationMyApplicationControllerGetMyApplication();
      } catch (e) {
        myApps = { data: [] };
      }
      this.$store.commit("basic/updateMyApplications", myApps.data);
    },
  },
  mounted() {
    this.getSubscribeVersionUserSetting();
    this.getMyApplications();
  },
};
</script>

<style lang="scss">
@import "../assets/config.scss";

.layout-menu {
  .first-level-active {
    .el-submenu__title {
      color: $theme-color;

      i {
        color: $theme-color;
      }
    }
  }

  .second-level-active {
    color: $theme-color;

    i {
      color: $theme-color !important;
    }
  }

  .third-level-expand {
    // 三级菜单打开时，红底保持
    border-left: 2px $theme-color solid !important;
    background-color: #fcefee;
  }

  .el-menu {
    border: none;
  }

  // 无二级菜单
  // title样式
  .el-menu-item {
    border-left: 2px white solid;
    padding-left: 24px !important;
  }

  // icon颜色
  .el-menu-item i {
    color: #333;
  }

  // hover focus 效果
  .el-menu-item:hover,
  .el-menu-item:focus {
    border-left: 2px $theme-color solid;
    background-color: #fcefee;
  }

  // 有二级菜单
  // title样式
  .el-submenu__title {
    border-left: 2px white solid;
    padding-left: 24px !important;
  }

  // icon颜色
  .el-submenu__title i {
    color: #333;
  }

  // 箭头样式
  .el-submenu__icon-arrow {
    right: 33px;
  }

  // hover focus 效果
  .el-submenu__title:hover,
  .el-submenu__title:focus {
    border-left: 2px $theme-color solid;
    background-color: #fcefee;
  }

  // 二级菜单样式
  .el-submenu {
    .el-menu-item {
      padding-left: 48px !important;
      display: flex;
      justify-content: space-between;
      padding-right: 20px;

      .third-level-open {
        font-size: 12px;
        color: #666;
        margin-right: 13px;
      }
    }
  }

  .second-level-no-children {
    .el-menu-item {
      justify-content: flex-start;
    }

    .icon-beta {
      width: 45px;
      height: 18px;
      margin-top: 14.5px;
      margin-left: 4px;
    }

    .icon-new {
      width: 36px;
      height: 16px;
      margin-top: 14.5px;
      margin-left: 4px;
    }

    .icon-free {
      width: 33px;
      height: 17px;
      margin-top: 14.5px;
      margin-left: 4px;
    }
  }

  // 骨架屏
  .el-skeleton {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .skeleton-item {
    width: 80%;
    height: 30px;
    margin: 6px 0;
  }
}

// 三级菜单样式
.menu_third_level {
  z-index: 998 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;

  .menu_third_level_content {
    max-height: $layout-menu-third-level-max-height;
    overflow-y: auto;

    // title样式
    .el-menu-item {
      padding-left: 25px !important;
      padding-right: 45px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #333333;

      display: flex;
      align-items: center;

      border-left: 2px white solid;
    }

    // icon颜色
    .el-menu-item i {
      font-weight: 600;
      color: #333;
      margin-right: 10px;
    }

    // hover focus 效果
    .el-menu-item:hover,
    .el-menu-item:focus {
      border-left: 2px $theme-color solid;
      background-color: #fcefee;
    }

    // 三级菜单激活
    .third-level-active {
      color: $theme-color;

      i {
        color: $theme-color;
      }
    }

    // 四级菜单样式
    .menu_forth_level {
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #666666;
      padding-left: 51px !important;
    }

    .forth-level-active {
      color: $theme-color;

      i {
        color: $theme-color;
      }
    }
  }
}
</style>

<style scoped lang="scss">
@import "../assets/config.scss";

.layout-menu {
  width: $layout-menu-width;
  height: fit-content;
  min-height: $layout-menu-min-height;
  margin-right: $layout-menu-margin-right;
  flex-shrink: 0;
  padding: 16px 0;
  background-color: white;
  font-weight: 400;

  .menu_title {
    font-weight: 600;
  }

  .iconfont {
    font-weight: 600;
    margin-right: 10px;
  }
}
</style>
